// Before/after slider: range input drives a CSS variable.
document.querySelectorAll('[data-ba]').forEach((ba) => {
  const range = ba.querySelector('input[type=range]');
  const set = () => ba.style.setProperty('--pos', range.value + '%');
  range.addEventListener('input', set);
  set();
});

// Fit finder: sizes come from section blocks (data-sizes). No ranges set = email fallback.
document.querySelectorAll('[data-fit]').forEach((form) => {
  const sizes = JSON.parse(form.dataset.sizes || '[]');
  const out = form.querySelector('[data-fit-result]');
  const email = form.dataset.email;

  form.addEventListener('submit', (e) => {
    e.preventDefault();
    const breed = form.breed.value.trim();
    const weight = parseFloat(form.weight.value);
    const waist = parseFloat(form.waist.value);
    if (!(weight > 0) || !(waist > 0)) {
      out.hidden = false;
      out.innerHTML = 'Enter your dog’s weight and waist measurement to see a size.';
      return;
    }
    // Waist decides first (fit), weight breaks ties; between sizes -> larger.
    const byWaist = sizes.filter((s) => waist >= s.waistMin && waist <= s.waistMax);
    const pick = (byWaist.length ? byWaist : sizes.filter((s) => weight >= s.weightMin && weight <= s.weightMax)).pop();

    const body = encodeURIComponent(`Breed: ${breed || '-'}\nWeight: ${weight} lb\nWaist: ${waist} in`);
    const mail = `mailto:${email}?subject=${encodeURIComponent('Which harness size?')}&body=${body}`;
    out.hidden = false;
    if (pick) {
      out.innerHTML = `<strong>Size ${pick.name}</strong>Recommended for ${weight} lb and a ${waist}" waist. Between sizes? Go one up.`;
      const radio = document.querySelector(`.sizes input[data-size="${pick.name}"]`);
      if (radio && !radio.disabled) radio.checked = true;
    } else {
      out.innerHTML = `<strong>We’ll size it for you</strong>Send us these measurements and we’ll reply with the right size, usually within a day. <a href="${mail}">Email your measurements</a>`;
    }
  });
});

// Buy now = one fresh item. /cart/add stacks on the old cart, so a buyer who comes back and taps again would land on checkout with 2 harnesses ($69.90).
// ponytail: clears the whole cart; fine while the harness is the only active product — revisit if bundles go live.
document.querySelectorAll('.buy__form').forEach((form) => {
  form.addEventListener('submit', (e) => {
    e.preventDefault();
    fetch('/cart/clear.js', { method: 'POST' }).finally(() => form.submit());
  });
});

// Variant picker: keep every price on the page in sync with the chosen option (pack sizes have different prices).
document.querySelectorAll('.buy__form input[name="id"][data-price]').forEach((radio) => {
  radio.addEventListener('change', () => {
    document.querySelectorAll('[data-price-display]').forEach((el) => { el.textContent = radio.dataset.price; });
  });
});

// Multi-option products (e.g. Color + Pack): resolve the chosen radios to a variant id and price.
// ponytail: '$' + cents/100 because the store sells in USD only; use a money format if more currencies are added.
document.querySelectorAll('.buy__form').forEach((form) => {
  const data = form.querySelector('[data-variants]');
  if (!data) return;
  const variants = JSON.parse(data.textContent);
  const idInput = form.querySelector('[data-variant-id]');
  const buy = form.querySelector('button[type="submit"]');
  form.addEventListener('change', (e) => {
    if (!e.target.name || !e.target.name.startsWith('opt')) return;
    const chosen = [];
    form.querySelectorAll('[data-option]').forEach((fs) => { chosen[+fs.dataset.option] = (fs.querySelector('input:checked') || {}).value; });
    const v = variants.find((x) => x.options.every((o, i) => o === chosen[i]));
    if (!v) return;
    idInput.value = v.id;
    document.querySelectorAll('[data-price-display]').forEach((el) => { el.textContent = '$' + (v.price / 100).toFixed(2); });
    if (buy) buy.disabled = !v.available;
  });
});
